import { useSyncExternalStore } from 'react';
import { Link } from 'react-router-dom';
import { accountNow, getVersion, subscribe } from '../lib/whoami';

/**
 * The end-of-game ask: keep these scores by making an account. Only when nobody is signed in
 * (and not while that is still unknown). The finished seat's token is already saved with the
 * result, so the game moves onto the account as soon as it exists (`lib/results.ts`).
 */
export function AccountNudge() {
  useSyncExternalStore(subscribe, getVersion, getVersion);
  if (accountNow() !== null) return null;
  return (
    <p className="account-nudge">
      <Link to="/signin?signup">Create an account</Link> to keep your scores and see them on any
      device. <Link to="/signin">Sign in</Link> if you have one.
    </p>
  );
}
